import { render } from "./SearchHeader.vue?vue&type=template&id=74df684a&scoped=true"
import script from "./SearchHeader.vue?vue&type=script&lang=js"
export * from "./SearchHeader.vue?vue&type=script&lang=js"

import "./SearchHeader.vue?vue&type=style&index=0&id=74df684a&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74df684a"]])

export default __exports__